export default __webpack_public_path__ + "static/media/filter-icon.81b725aa.svg";